import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/suppliers', { params }),
  create: params => axios.post('/api/v1/avg/suppliers', params),
  update: params => axios.put(`/api/v1/avg/suppliers/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/suppliers', { params })
};
